import { PaymentRequestForm } from '@/features/InvoiceReport/Edit/type';
import { useCallback } from 'react';
import { UseFieldArrayReplace } from 'react-hook-form';

type UseFillPaymentRequestDetailsProps = {
  replace: UseFieldArrayReplace<PaymentRequestForm, 'invoiceTransactions'>;
  resetInvoiceTransactionsField: () => void;
};

type PaymentRequestDetailsProps = PaymentRequestForm['invoiceTransactions'];

export const useFillPaymentRequestDetails = ({
  replace,
  resetInvoiceTransactionsField,
}: UseFillPaymentRequestDetailsProps) => {
  const fillPaymentRequestDetails = useCallback(
    (paymentRequestDetails: PaymentRequestDetailsProps) => {
      // TODO: Resolve React errors (same errors as when using CSV import)
      resetInvoiceTransactionsField();
      replace(paymentRequestDetails);
    },
    [replace, resetInvoiceTransactionsField]
  );
  return fillPaymentRequestDetails;
};
